'use strict';

exports.__esModule = true;
exports.SocialIcon = undefined;

var _socialIcon = require('./social-icon');

var _socialIcon2 = _interopRequireDefault(_socialIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SocialIcon = _socialIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-social-icons/lib/react-social-icons.js
// module id = 2571
// module chunks = 0